import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Icon } from "@foris/avocado-icons";
import { Tooltip } from "@foris/avocado-suite";
import styles from "./copyButton.module.scss";

interface CopyButtonProps {
  textToCopy: string;
}

const CopyButton = ({ textToCopy }: CopyButtonProps) => {
  const { t } = useTranslation();
  const [showTooltip, setShowTooltip] = useState(false);

  const handleCopyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(textToCopy);

      setShowTooltip(true);
      setTimeout(() => {
        setShowTooltip(false);
      }, 500);
    } catch (err) {
      console.error("No se pudo copiar en el portapapeles");
    }
  };

  return (
    <Tooltip placement="top" visible={showTooltip} label={t("dimension.population.btn-copy")}>
      <button className={styles.copyButton} onClick={handleCopyToClipboard}>
        <Icon name="copy" color="gray-30" />
      </button>
    </Tooltip>
  );
};

export default CopyButton;
